import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiInstance } from "./axiosApi";
import authHeader from "./authHeader";

// 🔹 Get all workshop registrations
export const getWorkshopRegisters = createAsyncThunk(
  "admin/allWorkshopRegisters",
  async ({ page, limit, searchData, workshopId }, { rejectWithValue }) => {
    try {
      let url = `/workshop-register/all?page=${page}&limit=${limit}`;
      if (searchData) url += `&search=${searchData}`;
      if (workshopId) url += `&workshopFilter=${workshopId}`
      const response = await apiInstance.get(url, { headers: authHeader() });
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

// Get single workshop register
export const getSingleWorkshopRegister = createAsyncThunk(
  "admin/singleWorkshopRegister",
  async (registerId, { rejectWithValue }) => {
    try {
      const response = await apiInstance.get(`/workshop-register/${registerId}`, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

//  Edit workshop register
export const editWorkshopRegister = createAsyncThunk(
  "admin/editWorkshopRegister",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post(`/workshop-register/edit`, payload, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

// 🔹 Delete workshop register
export const deleteWorkshopRegister = createAsyncThunk(
  "admin/deleteWorkshopRegister",
  async (selectedId, { rejectWithValue }) => {
    try {
      const response = await apiInstance.delete(`/workshop-register/delete/${selectedId}`, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

export const getWorkshopRegistersBill = createAsyncThunk(
  "admin/WorkshopRegistersBill",
  async ({ workshopId }, { rejectWithValue }) => {
    try {
      let url = `/workshop-register/bill/generate`;
      if (workshopId) url += `?workshopId=${workshopId}`
      const response = await apiInstance.get(url, { headers: authHeader() });
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

const initialState = {
  workshopRegisterData: [],
  singleWorkshopRegister: {},
  workshopRegisterBillData: "",
};

const workshopRegisterSlice = createSlice({
  name: "workshopRegisterSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getWorkshopRegisters.fulfilled, (state, action) => {
      state.workshopRegisterData = action.payload.data;
    });
    builder.addCase(getSingleWorkshopRegister.fulfilled, (state, action) => {
      state.singleWorkshopRegister = action.payload.data;
    });
    builder.addCase(getWorkshopRegistersBill.fulfilled, (state, action) => {
      state.workshopRegisterBillData = action.payload.data;
    });
  },
});

export default workshopRegisterSlice.reducer;
